/* eslint-disable */
import React from "react";
import { Box, Button } from "@mui/material";
// @ts-ignore
import { StriimButton } from "@striim/striim-ui";

interface SidebarStepFooterProps {
    onBack?: () => void;
    onNext?: () => void;
    onCancel?: () => void;
    nextLabel?: string;
    nextDisabled?: boolean;
    backDisabled?: boolean;
    showBack?: boolean;
    showNext?: boolean;
}

const gradientSx = {
    background:
        "linear-gradient(132deg, rgba(243, 23, 121, 0.80) 0.9%, rgba(121, 48, 217, 0.80) 66.21%, rgba(17, 0, 0, 0.80) 127.52%)",
    color: "white",
    "&:disabled": { color: "white", opacity: 0.5 }
};

const SidebarStepFooter = ({
    onBack,
    onNext,
    onCancel,
    nextLabel = "Next",
    nextDisabled = false,
    backDisabled = false,
    showBack = true,
    showNext = true
}: SidebarStepFooterProps) => (
    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2, width: "100%" }}>
        <StriimButton variant="secondary" onClick={onCancel} size="small">
            Cancel
        </StriimButton>
        <Box sx={{ display: "flex", gap: 1 }}>
            {showBack && (
                <StriimButton variant="secondary" size="small" disabled={backDisabled} onClick={onBack}>
                    Back
                </StriimButton>
            )}
            {showNext && (
                <StriimButton variant="primary" size="small" disabled={nextDisabled} onClick={onNext}>
                    {nextLabel}
                </StriimButton>
            )}
        </Box>
    </Box>
);

export default SidebarStepFooter;
